import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

export const AnnouncementBar = ({ data }) => {
  if (!data || !data.text) return null;
  const content = (
    <div className="flex items-center justify-center gap-2 h-10 px-4 text-center">
      <Sparkles className="h-4 w-4 text-[#d9b64e] shrink-0" />
      <span className="text-xs sm:text-sm font-medium tracking-wide truncate">{data.text}</span>
    </div>
  );
  return (
    <motion.div
      initial={{ y: -40 }} animate={{ y: 0 }} transition={{ duration: 0.5 }}
      data-testid="announcement-bar"
      className="w-full bg-[var(--forest)] text-[var(--cream)]"
    >
      {data.link ? (
        <a href={data.link} target="_blank" rel="noopener noreferrer" className="block hover:opacity-90 transition-opacity">{content}</a>
      ) : content}
    </motion.div>
  );
};
